import classNames from 'classnames';
import React, {ReactNode} from 'react';

import {ROLES} from './Menu';

interface Props {
  children: ReactNode;
  className?: string;
  // Specify when component is being used in a list
  itemKey?: string;

  // Do not define `_role` -- this is used internally by the component.
  _role: string;
}
/**
 * Renders a section header in a Menu. See Menu implementation.
 *
 * <Section>
 *   <SectionHeader>Section Header</SectionHeader>
 *   <Option>Option 2</Option>
 * </Section>
 */
export default function SectionHeader({children, className, itemKey}: Props): JSX.Element {
  return (
    <li key={itemKey} className={classNames('menu-sectionHeader', className)}>
      {children}
    </li>
  );
}

SectionHeader.defaultProps = {
  _role: ROLES.SECTION_HEADER,
};
